/**
 * Site footer for the public pages.
 *
 * Carries the product's own links, the contact address and the company
 * credit fixed in framing V11 ("Built by RPEQ Consulting, Brisbane").
 * Product voice only — no personal name, no service promise.
 */

import Link from './Link';
import { CONTACT_EMAIL, LEARN_ROUTE_LIST } from '../lib/route';
import './SiteFooter.css';

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-col">
          <h2 className="site-footer-heading">SigTDD</h2>
          <p className="site-footer-text">
            Time-distance (time-space) diagrams for traffic signal coordination, in the browser.
          </p>
          <p className="site-footer-text">
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </p>
        </div>
        <div className="site-footer-col">
          <h2 className="site-footer-heading">Product</h2>
          <ul className="site-footer-list">
            <li><Link to="/app">Open the tool</Link></li>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/docs" event="docs-open" source="footer">Documentation</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div className="site-footer-col">
          <h2 className="site-footer-heading">Learn</h2>
          <ul className="site-footer-list">
            {LEARN_ROUTE_LIST.map((route) => (
              <li key={route.path}>
                <Link to={route.path} event="learn-open" source="footer">{route.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="site-footer-credit">
        Built by <a href="https://rpeq.com.au/">RPEQ Consulting, Brisbane</a>
      </div>
    </footer>
  );
}
